import { c as _c } from "react/compiler-runtime";
import React from "react";
import ApprovalDropVoteSummary from "@/components/waves/drops/ApprovalDropVoteSummary";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import ParticipationDropVoteDetailsTrigger from "@/components/waves/drops/participation/ratings/ParticipationDropVoteDetailsTrigger";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface WaveLeaderboardDropRatersProps {
  readonly drop: ExtendedDrop;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export const WaveLeaderboardDropRaters: React.FC<WaveLeaderboardDropRatersProps> = t0 => {
  const $ = _c(32);
  const {
    drop,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t1
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const displayWinningThreshold = typeof winningThreshold === "number" && Number.isFinite(winningThreshold) && winningThreshold > 0 ? winningThreshold : null;
  const hasWinningThreshold = displayWinningThreshold !== null;
  if (hasWinningThreshold) {
    let t2;
    if ($[0] !== displayWinningThreshold || $[1] !== drop || $[2] !== isVotingClosed || $[3] !== winningThresholdMinDurationMs) {
      t2 = <ApprovalDropVoteSummary drop={drop} winningThreshold={displayWinningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} variant="leaderboard" />;
      $[0] = displayWinningThreshold;
      $[1] = drop;
      $[2] = isVotingClosed;
      $[3] = winningThresholdMinDurationMs;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const totalVote = drop.rating;
  const userVote = drop.context_profile_context?.rating ?? 0;
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  const totalVoteClass = totalVote < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const userVoteClass = userVote < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const hasUserVoted = userVote !== 0;
  const t2 = `tw-font-medium ${totalVoteClass}`;
  let t3;
  if ($[5] !== totalVote) {
    t3 = formatNumberWithCommas(totalVote);
    $[5] = totalVote;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== drop.rating || $[11] !== drop.rating_prediction) {
    t5 = <DropVoteProgressing current={drop.rating} projected={drop.rating_prediction} compact={true} />;
    $[10] = drop.rating;
    $[11] = drop.rating_prediction;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="tw-relative tw-inline-flex tw-items-center tw-gap-x-1.5">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== votingLabel) {
    t7 = <span className="tw-whitespace-nowrap tw-font-normal tw-text-iron-400">{votingLabel} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[16] = votingLabel;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== drop) {
    t9 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5"><ParticipationDropVoteDetailsTrigger drop={drop} /></div>;
    $[21] = drop;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== hasUserVoted || $[24] !== userVote || $[25] !== userVoteClass || $[26] !== votingLabel) {
    t10 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><span className="tw-whitespace-nowrap"><span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:{" "}</span><span className={`tw-font-medium ${userVoteClass}`}>{formatNumberWithCommas(userVote)} {votingLabel}</span></span></div>;
    $[23] = hasUserVoted;
    $[24] = userVote;
    $[25] = userVoteClass;
    $[26] = votingLabel;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
    t11 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 sm:tw-justify-end">{t8}{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};